import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { dom } from '@fortawesome/fontawesome-svg-core';

Vue.component('fa-icon', FontAwesomeIcon);

dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
						 // Преобразование <i class='fa fa-...'> к font-awesome svg иконкам

/* ИСПОЛЬЗУЕМЫЕ ИКОНКИ */
import {
	faBullhorn,
	faCamera,
	faCaretDown,
	faCaretUp,
	faCaretLeft,
	faCheck,
	faClipboardCheck,
	faDatabase,
	faEdit,
	faEye,
	faExclamationCircle,
	faExclamationTriangle,
	faHome,
	faImages,
	faLayerGroup,
	faLink,
	faLock,
	faMap,
	faMousePointer,
	faPlus,
	faSignInAlt,
	faSyncAlt,
	faTasks,
	faTimes,
	faTrash,
	faTree,
	faVectorSquare
} from '@fortawesome/free-solid-svg-icons';

library.add(
	faBullhorn,
	faCamera,
	faCaretDown,
	faCaretUp,
	faCaretLeft,
	faCheck,
	faClipboardCheck,
	faDatabase,
	faEdit,
	faEye,
	faExclamationCircle,
	faExclamationTriangle,
	faHome,
	faImages,
	faLayerGroup,
	faLink,
	faLock,
	faMap,
	faMousePointer,
	faPlus,
	faSignInAlt,
	faSyncAlt,
	faTasks,
	faTimes,
	faTrash,
	faTree,
	faVectorSquare
);
